// extracted by mini-css-extract-plugin
export default {"ContentOverlay":"styles_ContentOverlay__XgxaI"};